import React, { useState } from 'react';
import './RequirementsPanel.css';

function RequirementsPanel({ questions = [], selectedQuestion, onQuestionChange }) {
  const [activeTab, setActiveTab] = useState('functional');

  const getPriorityBadge = (difficulty) => {
    const colors = {
      easy: 'var(--success)',
      medium: 'var(--warning)',
      hard: 'var(--error)'
    };
    return colors[difficulty] || 'var(--text-muted)';
  };

  return (
    <>
      {/* Question Details */}
      {selectedQuestion && (
        <div className="question-details">
          <h3>{selectedQuestion.title}</h3>
          <p className="question-description">{selectedQuestion.description}</p>
          <div className="difficulty-badge" style={{ backgroundColor: getPriorityBadge(selectedQuestion.difficulty) }}>
            {selectedQuestion.difficulty?.toUpperCase()}
          </div>
        </div>
      )}

      <div className="requirements-tabs">
        <button
          className={`tab ${activeTab === 'functional' ? 'active' : ''}`}
          onClick={() => setActiveTab('functional')}
        >
          Functional
        </button>
        <button
          className={`tab ${activeTab === 'non-functional' ? 'active' : ''}`}
          onClick={() => setActiveTab('non-functional')}
        >
          Non-Functional
        </button>
        <button
          className={`tab ${activeTab === 'estimates' ? 'active' : ''}`}
          onClick={() => setActiveTab('estimates')}
        >
          Scale
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'functional' && selectedQuestion && (
          <div className="requirements-list">
            {selectedQuestion.functional_requirements?.map((req, idx) => (
              <div key={`fr-${idx}`} className="requirement-card">
                <span className="requirement-bullet">•</span>
                <span className="requirement-text">{req}</span>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'non-functional' && selectedQuestion && (
          <div className="requirements-list">
            {selectedQuestion.non_functional_requirements?.map((req, idx) => (
              <div key={`nfr-${idx}`} className="requirement-card">
                <span className="requirement-bullet">•</span>
                <span className="requirement-text">{req}</span>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'estimates' && selectedQuestion?.scale_estimates && (
          <div className="estimates-section">
            <h3>📊 Scale Estimates</h3>
            <div className="estimates-grid">
              {Object.entries(selectedQuestion.scale_estimates).map(([key, value]) => (
                <div key={key} className="estimate-item">
                  <span className="estimate-label">{key.replace(/_/g, ' ')}</span>
                  <span className="estimate-value">{value}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default RequirementsPanel;


